module.exports = __webpack_public_path__ + "static/media/maxisoft_logo_jekalo_reverse.6c11313a.png";